import { mapActions } from "vuex"

export default {
  methods: {
    ...mapActions({
      getNfplusUserByLogin: "userInfo/getNfplusUserByLogin"
    }),
    async nfplusLogin() {
      const hasUserInfo = await this.getNfplusUserByLogin()
      return hasUserInfo
    }
  }
}
